import IndustryPageTemplate from "@/components/IndustryPageTemplate";

const Manufacturing = () => (
  <IndustryPageTemplate
    seoTitle="Manufacturing Freight Logistics | Varstar Alliance"
    seoDesc="Reliable freight for manufacturers. On-time delivery, real-time tracking."
    canonical="/industries/manufacturing"
    h1={"Your production line doesn't wait.\nNeither do we."}
    subtitle="Reliable freight for manufacturers who cannot afford downtime."
    industry="Manufacturing"
    problem="Production schedules run 24/7. When a carrier no-shows or delivers late, the whole line stops - and every hour costs thousands. Most brokers treat manufacturing freight like any other load. It's not."
    solutions={[
      { title: "On-time delivery obsession" },
      { title: "Backup carriers pre-vetted on all critical lanes" },
      { title: "Real-time delay alerts (proactive, not reactive)" },
      { title: "Flatbed + dry van + specialized" },
      { title: "Cross-border for US-Canada manufacturing lanes" },
    ]}
    statBanner="98% on-time delivery for manufacturing clients."
    faqs={[
      { q: "What equipment do you offer for manufacturing?", a: "Dry van, flatbed, step deck, and specialized equipment for oversized manufacturing components." },
      { q: "Can you handle JIT deliveries?", a: "Yes. We specialize in just-in-time for manufacturing, with backup carriers pre-vetted on all critical lanes." },
      { q: "Do you offer cross-border manufacturing freight?", a: "Absolutely. Our Detroit HQ means we're minutes from the busiest US-Canada commercial crossing." },
      { q: "How do you handle production shutdowns?", a: "We have expedited and hot shot capabilities for emergency shipments to prevent or minimize downtime." },
    ]}
  />
);

export default Manufacturing;
